import React from 'react';
import { ZapIcon, TargetIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function BenefitsAndTopicsSection() {
  const benefits = ['Pasarás de quedarte en blanco frente a un diagrama → a entenderlo paso a paso', 'Aprenderás la lógica real de los comandos eléctricos', 'Podrás montar tableros sin depender de otro técnico', 'Tendrás más confianza para aceptar trabajos mejor pagados'];
  const topics = ['Lectura de diagramas eléctricos', 'Circuitos de mando y potencia', 'Contactores y relés', 'Lógica de control', 'Montaje de tableros', 'Diagnóstico de fallas'];
  return <section className="bg-cream py-8 px-4" data-id="element-40">
      <div className="max-w-[600px] mx-auto" data-id="element-41">
        <h2 className="text-[24px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-42">
          <TargetIcon className="w-6 h-6 text-primary" data-id="element-43" />
          ¿QUÉ LOGRARÁS Y QUÉ DOMINARÁS?
        </h2>

        {/* Benefits */}
        <div className="bg-brand-black-light border border-white/10 rounded-xl p-6 shadow-soft mb-6" data-id="element-44">
          <h3 className="text-primary font-bold text-lg mb-4 flex items-center gap-2" data-id="element-45">
            <ZapIcon className="w-5 h-5" data-id="element-46" />
            Lo que lograrás:
          </h3>
          <div className="space-y-4" data-id="element-47">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-48">
                <ZapIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-49" />
                <p className="text-dark-gray text-sm leading-relaxed m-0" data-id="element-50">
                  {benefit}
                </p>
              </div>)}
          </div>
        </div>

        {/* Topics */}
        <div className="mb-6" data-id="element-51">
          <h3 className="text-primary font-bold text-lg mb-4 flex items-center gap-2" data-id="element-52">
            <CheckCircleIcon className="w-5 h-5" data-id="element-53" />
            Conocimientos que dominarás:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-54">
            {topics.map((topic, index) => <div key={index} className="flex items-center gap-3 bg-brand-black-light border border-white/10 rounded-lg p-3 shadow-sm" data-id="element-55">
                <CheckCircleIcon className="w-4 h-4 text-success flex-shrink-0" data-id="element-56" />
                <span className="text-dark-gray text-sm font-medium" data-id="element-57">
                  {topic}
                </span>
              </div>)}
          </div>
        </div>

        {/* Final message */}
        <div className="text-center bg-primary/10 border border-primary/20 rounded-lg p-4 flex items-center justify-center gap-2" data-id="element-58">
          <p className="text-primary font-bold text-base m-0 flex items-center gap-2" data-id="element-59">
            Y lo más importante: cómo conectar todo eso en la vida real
            <ArrowRightIcon className="w-5 h-5" data-id="element-60" />
          </p>
        </div>
      </div>
    </section>;
}